import { put, select, takeLatest } from 'redux-saga/effects';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { getInvestmentHoldingsV2Success } from 'app-components/flux/investment-holdings-v2/investmentHoldingsV2Actions';

import { getAllDetailedQuotes } from './investmentsQuotesDetailedThunks';

function* onHoldingsSuccess() {
  const investmentsDetailedQuotesRelease: boolean = yield select(
    featureFlagsSelectors.getFeatureFlag,
    'investmentsDetailedQuotesRelease',
  );
  if (investmentsDetailedQuotesRelease) {
    yield put(getAllDetailedQuotes());
  }
}

export function* investmentsQuotesDetailedSagas() {
  yield takeLatest(getInvestmentHoldingsV2Success.type, onHoldingsSuccess);
}

export default [investmentsQuotesDetailedSagas];
